<template>
    <div class="be-left-sidebar">
        <div class="left-sidebar-wrapper">
            <a :class="{ 'left-sidebar-toggle': true, open: showMobile }" href="#" @click.prevent="toggleMobile">{{ $route.meta.title }}</a>
            <div :class="{ 'left-sidebar-spacer': true, open: showMobile }">
                <div class="left-sidebar-scroll">
                    <div class="left-sidebar-content">
                        <ul class="sidebar-elements">
                            <li class="divider">Digital.Fitness</li>
                            <router-link tag="li" :to="{ name: 'framework' }"><a><i class="icon mdi mdi-balance"></i><span>Digital.Framework</span></a></router-link>
                            <router-link tag="li" :to="{ name: 'check' }"><a><i class="icon mdi mdi-assignment-o"></i><span>Digital.Check</span></a></router-link>
                            <li :class="{ parent: true, open: showGroup('solutions') }">
                                <a href="#" @click.prevent="toggleGroup('solutions')"><i class="icon mdi mdi-graduation-cap"></i><span>Digital.Solutions</span></a>
                                <ul class="sub-menu">
                                    <router-link tag="li" :to="{ name: 'tools' }"><a>Tools & Services</a></router-link>
                                    <router-link tag="li" :to="{ name: 'nanodegrees' }"><a>Nano-Degrees</a></router-link>
                                </ul>
                            </li>
                            <router-link tag="li" :to="{ name: 'cockpit' }"><a><i class="icon mdi mdi-chart-donut"></i><span>Digital.Cockpit</span></a></router-link>

                            <template v-if="isAuthenticated">
                                <li class="divider">Administration</li>
                                <router-link tag="li" :to="{ name: 'admin-assessments' }" v-if="hasRole('ROLE_ASSESSMENTS')"><a><i class="icon mdi mdi-assignment"></i><span>MyAssessments</span></a></router-link>
                                <router-link tag="li" :to="{ name: 'admin-customers' }" v-if="hasRole('ROLE_CUSTOMERS')"><a><i class="icon mdi mdi-male-female"></i><span>MyCustomers</span></a></router-link>
                                <router-link tag="li" :to="{ name: 'admin-solutions' }" v-if="hasRole('ROLE_SOLUTIONS')"><a><i class="icon mdi mdi-graduation-cap"></i><span>MySolutions</span></a></router-link>
                                <router-link tag="li" :to="{ name: 'admin-users' }" v-if="hasRole('ROLE_ADMIN')"><a><i class="icon mdi mdi-account"></i><span>Benutzerverwaltung</span></a></router-link>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';

    export default {
        computed: {
            ...mapState('navigation', ['showMobile']),
            ...mapGetters('navigation', ['showGroup']),
            ...mapGetters('user', ['isAuthenticated', 'hasRole', 'hasAnyRoles']),
        },

        methods: {
            ...mapMutations('navigation', ['toggleMobile', 'toggleGroup']),
        },
    };
</script>
